import React from "react";
import { Paging } from "@elastic/react-search-ui";
import RcPagination from "./RcPagination";

const OmronPagination = () => {
  return <Paging view={RcPagination} />;
};

export default OmronPagination;
